import React from 'react';
import { Modal } from 'ui-lib';
import { ISelectableTableProps } from './record-picker.types';
import { SelectableTable } from './selectable-table';

export interface IRecordPickerModalProps<T> extends Omit<ISelectableTableProps<T>, 'value' | 'onChange'> {
    isVisible: boolean;
    title: string;
    initialValue: T[];
    onConfirm: (records: T[]) => void;
    onCancel: () => void;
}

export const RecordPickerModal = <T,>(props: IRecordPickerModalProps<T>): JSX.Element => {
    const { isVisible, title, initialValue, onConfirm, onCancel, ...tableProps } = props;
    const [draftRecords, setDraftRecords] = React.useState<T[]>(initialValue);

    return (
        <Modal
            isVisible={isVisible}
            isClosable={true}
            title={title}
            width={1000}
            okText={props.selectionType === 'multiple' ? `Select (${draftRecords.length})` : 'Select'}
            onOk={() => onConfirm(draftRecords)}
            onCancel={onCancel}
        >
            <SelectableTable {...tableProps} value={draftRecords} onChange={setDraftRecords} />
        </Modal>
    );
};
